

import React, { Suspense, lazy } from 'react'
import './App.css';
import sumero from './images/Logo.png'
import Navbar from './Components/Navbar';
import Marquee from "react-fast-marquee";
import { Routes, Route } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';


const About = lazy(() => import('./Components/About'))
const Home = lazy(() => import('./Components/Home'))
const Product = lazy(() => import('./Components/Product'))
const Gallery = lazy(() => import('./Components/Gallery'))
const Contactus = lazy(() => import('./Components/contactus'))

function App() {

  return (
    <>
      <Marquee style={{backgroundColor:'orange'}} className='rounded mx-auto'>
        <span className='spanText' >
          Redefining Hygiene Standards – Experience the Power of Purity with Shriram Industry
        </span>
      </Marquee>
      <div className="container mt-4">
        <div className="container my-2 p-2">
          <div className="row">
            <Navbar>
               <img src={sumero} alt="" />
            </Navbar>
          </div>        
        </div>

    
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home/>} />
            <Route path="/About" element={<About />} />
            <Route path="/Product" element={<Product />} />
            <Route path="/Gallery" element={<Gallery />} />
            <Route path="/Contactus" element={<Contactus />} />
          </Routes>
        </Suspense>
      </div>
    </>
  );
}

export default App;
